import { useEffect } from 'react'
import Context from './Context'
import Layout from './Layout'
import useCreateStore from './useCreateStore'
import useFetchData from './useFetchData'
import useLogNavigation from 'hooks/useLogNavigation'

const Support: React.FC = () => {
  useLogNavigation("Soporte")
  const [states, actions] = useCreateStore()
  const queryHandler = useFetchData(states, actions)

  const props = {
    value: { states, actions, queryHandler }
  }

  useEffect(() => {
    return () => {
      queryHandler.remove()
    }
  }, [])

  return (
    <Context.Provider {...props}>
      <Layout />
    </Context.Provider>
  )
}

export default Support
